import { render } from "./testing.vue?vue&type=template&id=47e7f799&scoped=true"
import script from "./testing.vue?vue&type=script&lang=js"
export * from "./testing.vue?vue&type=script&lang=js"

import "./testing.vue?vue&type=style&index=0&id=47e7f799&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e7f799"]])

export default __exports__